/** Picks v2 or v1 of User Requests based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import RequestsPage   from './RequestsPage';
import RequestsPageV2 from './v2/RequestsPageV2';

export default function RequestsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? RequestsPageV2 : RequestsPage;
  return <Component {...props} />;
}
